export const SET_SIDEBAR_DISPLAY = 'setting/SET_SIDEBAR_DISPLAY';
